// import { Report55Container } from "../../../containers/SupportSystem/Reports/Report55Container";
import { ListReportSupportSubmitRequestContainer } from "../../../containers/SupportSystem/Reports/ListReportSupportSubmitRequestContainer";
export function ListReportSupportSubmitRequestPage() {
    return (
        <ListReportSupportSubmitRequestContainer />
    );

}